module.exports = __webpack_public_path__ + "img/geology.c7f68f68.jpg";